<template>
  <f7-page class="page-edit-wallet">
    <f7-navbar>
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>SỬA MÁY ĐÀO</f7-nav-title>
    </f7-navbar>
    <f7-block>
      <f7-segmented class="mb-1" strong>
        <f7-button :active="form_wallet.pool === '2miners'" @click.prevent="form_wallet.pool = '2miners'">
          2MINERS
        </f7-button>
      </f7-segmented>
      <f7-segmented strong>
        <f7-button :active="form_wallet.coin === 'ETH'" @click.prevent="form_wallet.coin = 'ETH'">
          ETHW
        </f7-button>
        <f7-button :active="form_wallet.coin === 'ETC'" @click.prevent="form_wallet.coin = 'ETC'">
          ETC
        </f7-button>
        <f7-button :active="form_wallet.coin === 'RVN'" @click.prevent="form_wallet.coin = 'RVN'">
          RVN
        </f7-button>
      </f7-segmented>
    </f7-block>
    <f7-list no-hairlines-md inset>
      <f7-list-input
        outline
        floating-label
        label="Tên máy"
        type="text"
        placeholder="Tên máy"
        clear-button
        :value="form_wallet.name"
        @input="form_wallet.name = $event.target.value"
      >
      </f7-list-input>
      <f7-list-input
        outline
        floating-label
        label="Địa chỉ máy"
        type="textarea"
        placeholder="Địa chỉ máy"
        clear-button
        :value="form_wallet.address"
        @input="form_wallet.address = $event.target.value"
      >
      </f7-list-input>
    </f7-list>
    <f7-block>
      <f7-button color="orange" fill @click.prevent="submitEditWallet">
        SỬA MÁY ĐÀO
      </f7-button>
    </f7-block>
  </f7-page>
</template>
<style scoped>
.segmented-strong .button.button-active {
  --f7-button-bg-color : rgba(255, 165, 0, 0.63);
}
</style>
<script>
import {
  f7Page,
  f7Navbar,
  f7NavLeft,
  f7NavTitle,
  f7Button,
  f7Segmented,
  f7List,
  f7ListInput,
  f7Block
} from 'framework7-vue';
import { mapState } from 'vuex';

export default {
  components: {
    f7Page,
    f7Navbar,
    f7NavLeft,
    f7NavTitle,
    f7Button,
    f7Segmented,
    f7List,
    f7ListInput,
    f7Block
  },
  props: {
    wallet: Object
  },
  data() {
    return {
      form_wallet: {
        pool: '2miners',
        coin: 'ETH',
        name: '',
        address: ''
      }
    }
  },
  computed: {
    ...mapState(['wallets'])
  },
  methods: {
    submitEditWallet() {
      this.$f7.preloader.show();
      this.$store.dispatch('editWallet', {
        old_data: this.wallet,
        new_data: this.form_wallet
      }).then(() => {
        this.$f7.preloader.hide();
        this.$f7router.back();
      }).catch((err) => {
        this.$f7.preloader.hide();
        this.$f7.dialog.alert(err, 'ERROR!');
      })
    }
  },
  mounted() {
    this.form_wallet = this._.cloneDeep(this.wallet);
  }
};
</script>
